import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { PaymentHistoryItem } from '../../@types/payment';

const fetchPaymentHistory = async (): Promise<PaymentHistoryItem[]> => {
  const res = await axiosInstance.get('/api/payments/payment-history');
  return res.data;
};

export const useGetPaymentHistory = () => {
  return useQuery({
    queryKey: ['paymentHistory'],
    queryFn: fetchPaymentHistory,
  });
};
